import { useBrand } from '@contexts/useBrand'
import { useEffect, useRef } from 'react'
// import CurrentLocationIcon from '@assets/icons/currentLocation.svg'

const Map = ({ searchData, triggerMarkers }) => {
  const mapsElement = useRef()
  const brand = useBrand()

  // const el = document.createElement('div')
  // el.innerHTML = <CurrentLocationIcon />

  useEffect(() => {
    window.customMap = new mapsWrapper.DynamicMap(mapsElement.current, {
      accessToken:
        brand === 'lexus'
          ? process.env.NEXT_PUBLIC_LEXUS_MAPBOX_TOKEN
          : process.env.NEXT_PUBLIC_TOYOTA_MAPBOX_TOKEN,
      countryCode: ['GB', 'IM', 'JE', 'GG'],
      language: 'en',
      addCountryBoundaries: true,
      highResBoundary: true,
      maxZoom: 15,
      minZoom: 4,
      zoomControl: 'bottom-right',
    })

    if (window.customMap && searchData.length > 0) {
      triggerMarkers(searchData[0].localDealerID, 'markers set')
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((permissionStatus) => {
            if (permissionStatus.state === 'granted') {
              navigator.geolocation.getCurrentPosition((position) => {
                const currentLocation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                }
                const currentLocationMarkerOptions = {
                  markerClick: () => {
                    window.customMap.focusOn({ coordinates: currentLocation })
                  },
                }
                window.customMap.addMarker(
                  currentLocation,
                  currentLocationMarkerOptions,
                )
              })
            }
          })
      }
    }
  }, [searchData])

  return (
    <div
      className={` w-[100%] h-screen max-h-[565px] toyota-map  ${
        searchData.length > 0 ? '' : ' hidden '
      }`}
      ref={mapsElement}
    ></div>
  )
}

export default Map
